import { Component, inject, OnInit } from '@angular/core';

import { FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CommonModule} from '@angular/common';

import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { Router, RouterLink } from '@angular/router';
import { UsersStore } from '@data-access/user/stores/users.store';
import { UserRole } from '@shared/interfacres/user';
import { PlanSelectDialog } from '@shared/components/plan-select-dialog/plan-select-dialog';
import { firstValueFrom } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressBar } from '@angular/material/progress-bar';


@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,

    ReactiveFormsModule,

    MatIcon,
    MatButton,
    RouterLink,
    MatProgressBar
  ],
  templateUrl: './login.html',
  styleUrl: './login.scss'
})
export class Login implements OnInit {
  isPasswordShown = false;
  store = inject(UsersStore);
  router = inject(Router);
  readonly dialog = inject(MatDialog);

  isLoading = false;
  // emailValidator = inject(EmailExistsValidator);

  form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  });

  ngOnInit() {
    if (this.store.user()) {
      if (this.store.user()?.role === UserRole.Admin) {
        this.router.navigate(['/admin/tracks']);
      } else {
        this.router.navigate(['/library']);
      }
    }
  }

  async signInWithEmail() {
    this.isLoading = true;
    const res: {status: string; error: string} = await this.store.login(this.form.value.email?.toLowerCase() || '', this.form.value.password || '');
    this.isLoading = false;
    if (res && res.status === 'ok') {
      if (this.store.user()?.role === UserRole.Admin) {
        this.router.navigate(['/admin/tracks']);
      } else {
        this.router.navigate(['/library']);
      }
    } else {
      if (res.error === 'Payment method required') {
        this.showPlanSelect();
      }
    }
  }

  async showPlanSelect() {
    const plans = await firstValueFrom(this.store.getPlans());
    const dialogRef = this.dialog.open(PlanSelectDialog, {
      data: {
        plans: plans
      },
      disableClose: true,
      width: '85%',
      maxWidth: '1500px',
      panelClass: 'admin-dialog',
      backdropClass: 'admin-dialog-backdrop'
    });

    const productId = await firstValueFrom(dialogRef.afterClosed());
    if (productId) {
      this.isLoading = true;
      const link = await firstValueFrom(this.store.getCheckoutLink(productId, this.form.value.email?.toLowerCase() || ''))
      if (link && link !== '') {
        window.location.replace(link);
      } else {
        this.isLoading = false;
      }
    }
  }

}
